import { UnclaimedStatus } from "client/types";

export { default as useArchivedItems } from "./useArchivedItems";
export { default as useArchiveFilters } from "./useArchiveFilters";

// We want to exclude the NULL value from the list of unclaimed statuses
export const allArchiveUnclaimedStatuses = Object.keys(UnclaimedStatus).filter(u => u !== "NULL");
